import { Center, CenterProps, Text } from '@chakra-ui/react';

import { DayStyleConfig } from '../type';

type Props = CenterProps & {
  day?: number | string;
  dayStyleConfig: DayStyleConfig;
};

export const Normal = ({ day, dayStyleConfig, ...props }: Props) => {
  const { size, activeBgColor, activeColor, fontSize } = dayStyleConfig;

  return (
    <Center
      {...props}
      m="auto"
      h={size}
      w={size}
      cursor="pointer"
      pos="relative"
      _hover={{
        color: activeColor,
        _before: {
          bgColor: activeBgColor,
        },
      }}
      _before={{
        content: '""',
        pos: 'absolute',
        zIndex: '0',
        borderRadius: 'md',
        h: 'full',
        w: 'full',
        transition: 'all 300ms ease',
      }}
    >
      <Text pos="relative" fontSize={fontSize} color="inherit" zIndex="1" tabIndex={0}>
        {day}
      </Text>
    </Center>
  );
};
